// src/components/shared/ScrollDownArrow.js

import React, { useState, useEffect } from 'react';

const ScrollDownArrow = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isAtBottom, setIsAtBottom] = useState(false);

    useEffect(() => {
        const checkScroll = () => {
            const documentHeight = document.documentElement.scrollHeight;
            const viewportHeight = window.innerHeight;
            const scrollY = window.scrollY;

            // Sayfa içeriği görünür alandan daha uzunsa oku göster
            setIsVisible(documentHeight > viewportHeight + 100); // 100px'lik bir pay bırakalım

            // Kullanıcı sayfanın sonuna 200px kala oku gizle
            const bottomThreshold = 200;
            setIsAtBottom(scrollY + viewportHeight >= documentHeight - bottomThreshold);
        };

        checkScroll();
        window.addEventListener('scroll', checkScroll);
        window.addEventListener('resize', checkScroll);

        return () => {
            window.removeEventListener('scroll', checkScroll);
            window.removeEventListener('resize', checkScroll);
        };
    }, []);

    const handleScroll = () => {
        // Sayfayı, mevcut konumdan bir ekran boyu kadar aşağı kaydır
        window.scrollTo({
            top: window.scrollY + window.innerHeight * 0.85, // %85 ekran boyu kadar
            behavior: 'smooth',
        });
    };

    if (!isVisible || isAtBottom) {
        return null;
    }

    return (
        <div
            className="scroll-down-arrow"
            onClick={handleScroll}
            title="Aşağı Kaydır"
        >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 5.25 7.5 7.5 7.5-7.5" />
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 7.5 7.5 7.5-7.5" />
            </svg>
        </div>
    );
};

export default ScrollDownArrow;
